import { baseApi } from 'app/services/baseApi';
import { UserResponse, UsersResponse } from './userTypes';
import { User } from 'dataTypes/user';

const userApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getSelfUser: builder.query<UserResponse, void>({
      query: () => {
        return {
          url: `user/self`,
          method: 'GET',
        };
      },
    }),
    getUsers: builder.query<UsersResponse, string | void>({
      query: (queryParams: string) => {
        if (!queryParams)
          return {
            url: 'user/organization',
            method: 'GET',
          };
        return {
          url: `user/organization?${queryParams}`,
          method: 'GET',
        };
      },
      providesTags: ['users'],
    }),
    patchUser: builder.mutation<UserResponse, Partial<User> & Pick<User, 'id'>>({
      query: ({ id, ...patch }) => ({
        url: `user/salesforce/${id}/role`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['users'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetSelfUserQuery, useGetUsersQuery, usePatchUserMutation } = userApi;
